import styled from 'styled-components';
import { respondTo } from 'Utils/mediaQuery';

export const LogoutButton = styled.p`
  opacity: 0.5;
  position: fixed;
  right: 1rem;
  top: 4rem;
  transition: 0.5s;
  z-index: 9;

  button {
    box-shadow: var(--k-ds-shadow-lg);
    background-color: #ffdcdc;
    &:enabled:hover {
      background-color: #ff5252;
    }
  }

  &:hover {
    opacity: 1;
  }

  ${respondTo.medium`
    opacity: 1;
    scale: .5;
    top: 6rem;
    button {
      background-color: #ff5252;
    }
  `}
`;
